import SavingIndicator from 'app_components/commons/SavingIndicator/SavingIndicator'
import TooltipComponent from 'app_components/commons/TooltipComponent/TooltipComponent'
import CourseSchedulingService from 'app_services/admin/courseScheduling/courseSchedulingService'
import { CourseSchedulingProvisioningMoodleStatus, ICourseSchedulingListItem } from 'app_types/admin/courseScheduling/courseSchedulingTypes'
import React, { FC, useCallback, useMemo, useState } from 'react'
import { BounceLoader } from 'react-spinners'
import { IoReloadCircleOutline } from "react-icons/io5";
import LoadingWrapper from 'app_components/commons/LoadingWrapper/LoadingWrapper'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'


interface ICourseSchedulingMoodleStatusProps {
  courseScheduling: ICourseSchedulingListItem
  onServiceUpdated?: () => void
}

const CourseSchedulingMoodleStatus: FC<ICourseSchedulingMoodleStatusProps> = ({ courseScheduling, onServiceUpdated }) => {
  const courseSchedulingService = useMemo(() => new CourseSchedulingService(), [])
  const screenNotification = useMemo(() => new ScreenNotificationsUtil(), [])
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const handleClickSincrinizeService = useCallback(async () => {
    if (!courseScheduling?._id) return
    setIsLoading(true)
    const response = await courseSchedulingService.sincroniceServiceMoodle(courseScheduling._id)
    if (response?.code === 200) {
      screenNotification.showSuccessTimer()
      onServiceUpdated && onServiceUpdated()
    }
    setIsLoading(false)
  }, [courseSchedulingService, courseScheduling?._id])

  return (
    <div style={{ display: 'flex', justifyContent: 'center', width: '100%', gap: '8px' }}>
      <LoadingWrapper loading={isLoading} size='sm'>
        <>
          <TooltipComponent
            text={
              courseScheduling?.provisioningMoodle?.status === CourseSchedulingProvisioningMoodleStatus.ERROR ? 'Ha ocurrido un error con el servicio de Moodle' :
              courseScheduling?.provisioningMoodle?.status === CourseSchedulingProvisioningMoodleStatus.IN_PROCESS ? 'Creando servicio en Moodle' :
              'Moodle esta listo'
            }
          >
            <SavingIndicator
              state={
                courseScheduling?.provisioningMoodle?.status === CourseSchedulingProvisioningMoodleStatus.ERROR ? 'failed' :
                courseScheduling?.provisioningMoodle?.status === CourseSchedulingProvisioningMoodleStatus.IN_PROCESS ? 'saving' :
                'saved'
              }
              savingIcon={(
                <BounceLoader
                  color='var(--orange)'
                  size={19}
                />
              )}
            />
          </TooltipComponent>
          {courseScheduling?.provisioningMoodle?.status === CourseSchedulingProvisioningMoodleStatus.ERROR && (
            <TooltipComponent text='Reintentar sincronización'>
              <IoReloadCircleOutline
                color='var(--secondary)'
                size={22}
                style={{ cursor: 'pointer' }}
                onClick={handleClickSincrinizeService}
              />
            </TooltipComponent>
          )}
        </>
      </LoadingWrapper>
    </div>
  )
}

export default CourseSchedulingMoodleStatus
